import React from 'react';
import styles from './label.module.scss';
const Label = (props) => {
  const { children } = props;
  return <p className={styles.label}>{children}</p>;
};
export default Label;
